import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://applink.mobivent.fr/api';

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Charger l'utilisateur depuis localStorage au démarrage
  useEffect(() => {
    const token = localStorage.getItem('user_token');
    const savedUser = localStorage.getItem('user_data');
    
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (e) {
        console.error('Error parsing saved user:', e);
        localStorage.removeItem('user_token');
        localStorage.removeItem('user_data');
      }
    }
    setLoading(false);
  }, []);

  const register = async (userData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/register.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userData)
      });
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Registration error:', error);
      throw error;
    }
  };

  const sendCode = async (email, eventId, eventName) => {
    try {
      const response = await fetch(`${API_BASE_URL}/send_code.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, event_id: eventId, event_name: eventName })
      });
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Send code error:', error);
      throw error;
    }
  };

  const verifyCode = async (email, eventId, code) => {
    try {
      const response = await fetch(`${API_BASE_URL}/verify_code.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, event_id: eventId, code })
      });
      
      const data = await response.json();
      
      if (data.ok && data.user) {
        // Sauvegarder l'utilisateur et le token
        setUser(data.user);
        localStorage.setItem('user_token', data.session_token || 'temp_token');
        localStorage.setItem('user_data', JSON.stringify(data.user));
      }
      
      return data;
    } catch (error) {
      console.error('Verify code error:', error);
      throw error;
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user_token');
    localStorage.removeItem('user_data');
    localStorage.removeItem('current_event');
  };

  const isAuthenticated = () => {
    return !!localStorage.getItem('user_token');
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        register,
        sendCode,
        verifyCode,
        logout,
        isAuthenticated
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};